import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';
import { sortByNewest } from '../utils/sortByNewest';

export const fetchCronjobNotifications = createAsyncThunk('cronjobNotifications/fetchMany', async (params) => {
    const response = await api.get('/cronjob-notifications', { params });
    return response.data;
});

export const fetchCronjobNotificationById = createAsyncThunk('cronjobNotifications/fetchById', async (id) => {
    const response = await api.get(`/cronjob-notifications/${id}`);
    return response.data;
});

const Slice = createSlice({
    name: 'cronjobNotifications',
    initialState: {
        list: [],
        pagination: {
            currentPage: 1,
            totalPages: 0,
            totalCount: 0,
            limit: 50,
            hasMore: false
        },
        status: 'idle',
        error: null,
        selectedNotification: null,
        selectedStatus: 'idle',
        selectedError: null
    },
    reducers: {
        clearSelectedNotification: (state) => {
            state.selectedNotification = null;
            state.selectedStatus = 'idle';
            state.selectedError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch cronjob notifications
            .addCase(fetchCronjobNotifications.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCronjobNotifications.fulfilled, (state, action) => {
                state.status = 'success';
                state.list = sortByNewest(action.payload.data || action.payload);
                state.pagination = action.payload.pagination || state.pagination;
                state.error = null;
            })
            .addCase(fetchCronjobNotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message || 'An error occurred';
            })

            // Fetch single cronjob notification
            .addCase(fetchCronjobNotificationById.pending, (state) => {
                state.selectedStatus = 'loading';
            })
            .addCase(fetchCronjobNotificationById.fulfilled, (state, action) => {
                state.selectedStatus = 'success';
                state.selectedNotification = action.payload;
                state.selectedError = null;
            })
            .addCase(fetchCronjobNotificationById.rejected, (state, action) => {
                state.selectedStatus = 'failed';
                state.selectedError = action.error.message || 'An error occurred';
            });
    }
});

export const { clearSelectedNotification } = Slice.actions;
export default Slice.reducer;
